import {GradientButton, Icon, SelfExclusionModal, Settings} from "@housebets/housebets-x-package";
import React from "react";
import {useResponsiblePanelDate} from "./hooks/useResponsiblePanelData";
import {SelfExecutionForm} from "../forms";
import {FormattedMessage, useIntl} from "react-intl";

export const ResponsiblePanel: React.FC = (props) => {
    const {cooldown, setCooldown, cooldownMax, cooldownRemain, isModalOpen, setIsModalOpen} = useResponsiblePanelDate();
    const {$t} = useIntl();

    return (
        <div {...props}>
            <Settings.GamingPanel.GPanel opacity={cooldown}>
                <Settings.GamingPanel.GRow>
                    <Settings.GamingPanel.GCol>
                        <Settings.GamingPanel.GTitle>{$t({id: "ResponsiblePanel.title"})}</Settings.GamingPanel.GTitle>

                        {!cooldown && (
                            <Settings.GamingPanel.GText>
                                <p>{$t({id: "ResponsiblePanel.description1"})}</p>
                                <p>{$t({id: "ResponsiblePanel.description2"})}</p>
                                <p>{$t({id: "ResponsiblePanel.description3"})}</p>
                            </Settings.GamingPanel.GText>
                        )}

                        {cooldown && (
                            <Settings.GamingPanel.CooldownPanel>
                                <FormattedMessage id="ResponsiblePanel.cooldownPanel" values={{cooldownMax, cooldownRemain}} />
                                {/* Casino {cooldownMax} Cooldown - {cooldownRemain} */}
                            </Settings.GamingPanel.CooldownPanel>
                        )}
                    </Settings.GamingPanel.GCol>
                </Settings.GamingPanel.GRow>

                <Settings.GamingPanel.GRow className="responsible-row">
                    <Settings.GamingPanel.GCol>
                        <Settings.GamingPanel.GGPanel>
                            <Icon iconName="ClockOrangeV2" />

                            <Settings.GamingPanel.PanelTitle>
                                <FormattedMessage id="ResponsiblePanel.step1.title" />
                            </Settings.GamingPanel.PanelTitle>

                            <Settings.GamingPanel.PanelText>
                                <FormattedMessage id="ResponsiblePanel.step1.text" />
                            </Settings.GamingPanel.PanelText>
                        </Settings.GamingPanel.GGPanel>
                    </Settings.GamingPanel.GCol>

                    <Settings.GamingPanel.GCol>
                        <Settings.GamingPanel.GGPanel>
                            <Icon iconName="CalendarOrangeV2" />

                            <Settings.GamingPanel.PanelTitle>
                                <FormattedMessage id="ResponsiblePanel.step2.title" />
                            </Settings.GamingPanel.PanelTitle>

                            <Settings.GamingPanel.PanelText>
                                <FormattedMessage id="ResponsiblePanel.step2.text" />
                            </Settings.GamingPanel.PanelText>
                        </Settings.GamingPanel.GGPanel>
                    </Settings.GamingPanel.GCol>
                </Settings.GamingPanel.GRow>

                <Settings.GamingPanel.GRow>
                    <GradientButton
                        text={cooldown ? $t({id: "Modify"}) : $t({id: "Continue"})}
                        kind="fill"
                        onClick={() => {
                            setIsModalOpen(true);
                        }}
                    />
                </Settings.GamingPanel.GRow>
            </Settings.GamingPanel.GPanel>

            <SelfExclusionModal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                }}>
                <SelfExecutionForm
                    onSubmit={() => {
                        setIsModalOpen(false);
                        setCooldown(true);
                    }}
                    modifyType={cooldown}
                />
            </SelfExclusionModal>
        </div>
    );
};

ResponsiblePanel.displayName = "ResponsiblePanel";
